<template>
  <v-card>
    <v-toolbar flat color="primary">
      <v-toolbar-title>Teams</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="Object.values(user.all_teams)"
      hide-default-footer
      class="elevation-1"
      pagination.sync="pagination"
      item-key="id"
    >
      <template #[`item.actions`]="{ item }">
        <inertia-link :href="route('teams.show', item)" method="get" @click="$emit('input')">
          <v-icon>
            mdi-wrench
          </v-icon>
        </inertia-link>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
   props: {
      user: {
         type: Object,
         default: () => {},
      },
   },
   data () {
      return {
         headers: [
            {
               text: 'Name',
               align: 'start',
               filterable: false,
               value: 'name'
            },
            { text: 'Aktionen', value: 'actions', sortable: false, width: '20%' },
         ],
      }
   }
}
</script>

<style>

</style>
